<template>
  <apexchart
    type="bar"
    :options="chartOptions"
    :series="series"
    height="350"
  />
</template>

<script>
  import { toFixed } from '../../../utils/ramda-utils'
  import { BLUE, RED, } from '../../../constants/charts'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      series: {
        type: Array,
        default: () => []
      },
      countOfLearners: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      chartOptions() {
        return {
          count_of_learners: this.countOfLearners,
          chart: {
            animations: {
              enabled: true,
            },
            type: 'bar',
            toolbar:{
              show: false,
            }
          },
          plotOptions: {
            bar: {
              dataLabels: {
                position: 'top',
              },
            }
          },
          grid: {
            xaxis: {
              lines: {
                show: false
              }
            },   
            yaxis: {
              lines: {
                show: false
              }
            }
          },
          formatter: function (val, opts) {
            return val
          },
          xaxis: {
            type: 'category',
            categories: [['No IELTS', 'score'],['Band 5', 'and lower'], 'Band 6', 'Band 7', 'Band 8', 'Band 9'],
            labels: {
              rotate: 0,
              show: true,
              style: {
                colors: '#8E8E93',
                fontSize: '16px',
                lineHeight: '24px',
                fontWeight: 500,
                fontFamily: 'SF Pro Display, sans-serif',
              }
            },
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            max: 100,
            floating: true,
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: {
              show: false
            },
          },
          colors: [ 
            function ({ value, seriesIndex, dataPointIndex, w }) {
              if (dataPointIndex == 0) {
                return RED;
              } else {
                return BLUE;
              }
            }
          ],
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val + "%";
            },
            offsetY: -15,
            style: {
              fontSize: '14px',
              lineHeight: '36px',
              colors: ["#121131"]
            }
          },
          states: {
            hover: {
              filter: {
                type: 'none'
              }
            }
          },
          tooltip: {
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              return (
                '<div class="arrow_box">' +
                  "<span>" +
                    w.config.count_of_learners[dataPointIndex] +
                    " Learners" +
                  "</span>" +
                "</div>"
              );
            }
          },
          legend: {
            position: 'right',
            offsetX: 0,
            offsetY: 50
          },
        }
      },
      ...mapGetters('organization', ['currentOrganizationType'])
    }

  }
</script>

<style lang="scss" scoped>
::v-deep .arrow_box {
  position: relative;
  background: #C4C4C4;
  border-radius: 5px;
}
::v-deep .arrow_box:after {
  right: 40%;
  top: 150%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

::v-deep .arrow_box:after {
  border-color: rgba(85, 85, 85, 0);
  border-top-color: #C4C4C4;
  border-width: 5px;
  margin-top: -10px;
}


::v-deep .apexcharts-tooltip {
  color: #121131;
  font-size: 12px;
  line-height: 20px;
  transform: translateX(-40px) translateY(-50px);
  overflow: visible !important;
  font-family: 'SF Pro Display', sans-serif;
}

::v-deep .apexcharts-tooltip span {
  padding: 1px 6px;
  //display: inline-block;
}
</style>
